import { render, staticRenderFns } from "./StepMobils.vue?vue&type=template&id=424d504c&lang=html&"
import script from "./StepMobils.vue?vue&type=script&lang=js&"
export * from "./StepMobils.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports